import { DialogType } from '../../viewModel/dialogViewModel/dialogViewModel';
import { DailyAgendaActionFactory } from '../actions';

export type OnDialogConfirmAction = () => Promise<void>;

export const createOnDialogConfirmAction: DailyAgendaActionFactory<
  OnDialogConfirmAction
> = ({ setState, getState }) => {
  return async () => {
    const { dialog } = getState();
    if (!dialog) {
      return;
    }

    if (
      dialog.type === DialogType.JoinWaitlist ||
      dialog.type === DialogType.PremiumViewer ||
      dialog.type === DialogType.PremiumPreview
    ) {
      setState({
        dialog: undefined,
      });
    }
  };
};
